// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solutionDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.solutionGradDiv {
  width: 665px;
  height: 577px;
  flex-shrink: 0;
  position: absolute;
  right: 0;
  z-index: 0;
  border-radius: 665px;
  opacity: 0.6;
  background: rgba(240, 89, 42, 0.4);
  filter: blur(150px);
}

.solutionMain {
  display: flex;
  justify-content: center;
  z-index: 1;
}

.solutionMainDiv {
  border-radius: 2vw;
  background: linear-gradient(137deg, rgba(255, 182, 160, 0.2) 0%, rgba(240, 89, 42, 0.2) 18.54%, rgba(37, 60, 119, 0.2) 100%);
  padding: 1.8rem 3.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.solutionMainDiv_imgCol {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20%;
}
@media (max-width: 575px) {
  .solutionMainDiv_imgCol {
    width: 100%;
  }
}
.solutionMainDiv_secRow {
  width: 100%;
  padding: 0 1.8rem;
  margin-left: 0px !important;
}
@media (max-width: 575px) {
  .solutionMainDiv_secRow {
    padding: 0rem;
  }
}
.solutionMainDiv_image {
  width: 10vw !important;
}
@media (max-width: 575px) {
  .solutionMainDiv_image {
    width: 60vw !important;
  }
}
.solutionMainDiv_blueDiv {
  width: 14.4vw;
  border-radius: 1.4vh;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.5), rgba(240, 89, 42, 0.3)) !important;
  padding: 1px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .solutionMainDiv_blueDiv {
    width: 60vw !important;
  }
}
.solutionMainDiv_blueDiv span {
  width: 100%;
  height: 100%;
  border-radius: 1.4vh;
  background: #1d1a36 !important;
  color: #fff;
  font-size: 1.17vw;
  padding: 1.4vh;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .solutionMainDiv_blueDiv span {
    font-size: 18px;
  }
}

.solutionFour {
  padding: 0 3.6vw;
}
@media (max-width: 992px) {
  .solutionFour {
    padding: 0;
  }
}

.solutionFiveSix {
  width: 60% !important;
}
@media (max-width: 992px) {
  .solutionFiveSix {
    width: 60vw !important;
  }
}

.solutionLastDiv {
  width: 50% !important;
}
@media (max-width: 992px) {
  .solutionLastDiv {
    width: 60vw !important;
  }
}

.solutionLast {
  width: 100% !important;
  margin-top: -8px;
}
@media (max-width: 992px) {
  .solutionLast {
    width: 60vw !important;
  }
}
.solutionLast_image {
  display: flex;
  justify-content: center;
  height: 10vh !important;
}
.solutionLast_mobImage {
  display: flex;
}
@media (max-width: 992px) {
  .solutionLast_mobImage {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Solution/solution.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,4HAAA;EAMA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AAJF;AAME;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAJJ;AAKI;EALF;IAMI,WAAA;EAFJ;AACF;AAKE;EACE,WAAA;EACA,iBAAA;EACA,2BAAA;AAHJ;AAII;EAJF;IAKI,aAAA;EADJ;AACF;AAIE;EACE,sBAAA;AAFJ;AAGI;EAFF;IAGI,sBAAA;EAAJ;AACF;AAGE;EACE,aAAA;EACA,oBAAA;EACA,+FAAA;EAKA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;AAMI;EAZF;IAaI,sBAAA;EAHJ;AACF;AAME;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;AAKI;EAZF;IAaI,eAAA;EAFJ;AACF;;AAMA;EACE,gBAAA;AAHF;AAIE;EAFF;IAGI,UAAA;EADF;AACF;;AAIA;EACE,qBAAA;AADF;AAEE;EAFF;IAGI,sBAAA;EACF;AACF;;AAEA;EACE,qBAAA;AACF;AAAE;EAFF;IAGI,sBAAA;EAGF;AACF;;AAAA;EACE,sBAAA;EACA,gBAAA;AAGF;AAFE;EAHF;IAII,sBAAA;EAKF;AACF;AAHE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AAKJ;AAFE;EACE,aAAA;AAIJ;AAHI;EAFF;IAGI,aAAA;EAMJ;AACF","sourcesContent":[".solutionDiv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.solutionGradDiv {\n  width: 665px;\n  height: 577px;\n  flex-shrink: 0;\n  position: absolute;\n  right: 0;\n  z-index: 0;\n  border-radius: 665px;\n  opacity: 0.6;\n  background: rgba(240, 89, 42, 0.4);\n  filter: blur(150px);\n}\n\n.solutionMain {\n  display: flex;\n  justify-content: center;\n  z-index: 1;\n}\n\n.solutionMainDiv {\n  border-radius: 2vw;\n  background: linear-gradient(\n    137deg,\n    rgba(255, 182, 160, 0.2) 0%,\n    rgba(240, 89, 42, 0.2) 18.54%,\n    rgba(37, 60, 119, 0.2) 100%\n  );\n  padding: 1.8rem 3.75rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n\n  &_imgCol {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20%;\n    @media (max-width: 575px) {\n      width: 100%;\n    }\n  }\n\n  &_secRow {\n    width: 100%;\n    padding: 0 1.8rem;\n    margin-left: 0px !important;\n    @media (max-width: 575px) {\n      padding: 0rem;\n    }\n  }\n\n  &_image {\n    width: 10vw !important;\n    @media (max-width: 575px) {\n      width: 60vw !important;\n    }\n  }\n\n  &_blueDiv {\n    width: 14.4vw;\n    border-radius: 1.4vh;\n    background: linear-gradient(\n      45deg,\n      rgba(255, 255, 255, 0.5),\n      rgba(240, 89, 42, 0.3)\n    ) !important;\n    padding: 1px !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @media (max-width: 992px) {\n      width: 60vw !important;\n    }\n  }\n\n  &_blueDiv span {\n    width: 100%;\n    height: 100%;\n    border-radius: 1.4vh;\n    background: #1d1a36 !important;\n    color: #fff;\n    font-size: 1.17vw;\n    padding: 1.4vh;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    @media (max-width: 992px) {\n      font-size: 18px;\n    }\n  }\n}\n\n.solutionFour {\n  padding: 0 3.6vw;\n  @media (max-width: 992px) {\n    padding: 0;\n  }\n}\n\n.solutionFiveSix {\n  width: 60% !important;\n  @media (max-width: 992px) {\n    width: 60vw !important;\n  }\n}\n\n.solutionLastDiv {\n  width: 50% !important;\n  @media (max-width: 992px) {\n    width: 60vw !important;\n  }\n}\n\n.solutionLast {\n  width: 100% !important;\n  margin-top: -8px;\n  @media (max-width: 992px) {\n    width: 60vw !important;\n  }\n\n  &_image {\n    display: flex;\n    justify-content: center;\n    height: 10vh !important;\n  }\n\n  &_mobImage {\n    display: flex;\n    @media (max-width: 992px) {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
